export enum DataSourceFormat {
  /**
   *  纯数字,如：8
   */
  Format_8 = 1,

  /**
   *  数字前补零,如：08
   */
  Format_08 = 2,
  /**
   *  数字加单位,如：8时
   */
  Format_8时 = 3,
  /**
   *  数字前补零加单位,如：08时
   */
  Format_08时 = 4,
  /**
   *  单位加数字,如：SPF8
   */
  Format_SPF8 = 5,

  /**
   *  日期数值，如：8/16
   */
  'Format_8/16' = 11,
  /**
   *  日期月份补0，如：08/16
   */
  'Format_08/16' = 12,
  /**
   *  日期月份天数加单位，如：8月16日
   */
  'Format_8月16日' = 13,
  /**
   *  日期月份天数补零加单位，如：08月16日
   */
  'Format_08月16日' = 14,

  /**
   *  文本日期数值，如：8/16（不补零）
   */
  'Format_text_8/16' = 15,
  /**
   *  文本日期月份天数加单位，如：8月16日（不补零）
   */
  'Format_text_8月16日' = 16,

  /**
   *  时间数值，如：8:00
   */
  'Format_8:00' = 21,
  /**
   *  时间补零，如：08:00
   */
  'Format_08:00' = 22,

  /**
   *  时间数值含秒，如：8:00:00
   */
  'Format_8:00:00' = 23,
  /**
   *  时间补零含秒，如：08:00:00
   */
  'Format_08:00:00' = 24,

  /**
   *  纯数字,如：8.0
   */
  'Format_8.0' = 25,

  /**
   *  数字加单位,如：8.0时
   */
  'Format_8.0时' = 26,

  /**
   *  单位加浮点数字,如：SPF8.0
   * @deprecated
   */
  'Format_SPF8.0' = 27,
  /**
   *  农历年
   */
  'Format_甲子' = 28,

  /**
   *  数字加单位,如：8时
   */
  'Format_甲子年' = 29
}

/**
 * 数据源键枚举
 */
export enum DataSourceKey {
  /**
   * 天色完整版
   */
  tianSeFull = 'weatherTodayWeatherColorFull',
  /**
   * 天色精简版
   */
  tianseSimple = 'weatherTodayWeatherColorLite'
}
